var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 376,
    viewBox: "0 0 21 376",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DBDEE4",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.862 188.333-.966.258-.751-2.824C5.085 147.697.037 117.772 0 95.98l.004-1.345C.175 72.96 5.302 43.481 15.381 6.188l.769-2.823.964.263-.767 2.819-.938 3.502C5.767 46.278.965 74.958 1 95.978l.009 1.338c.235 21.576 5.269 50.979 15.103 88.197l.75 2.82z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.116 188.326-.964.268-.995-3.606-.832-3.066C8.775 161.296 6 147.327 6 139.98l.005-.543.015-.573c.265-7.989 3.27-22.599 9.015-43.866l.99-3.633.965.265-.772 2.825-.419 1.55C9.933 117.807 7 132.478 7 139.98l.005.535c.14 7.927 3.321 23.196 9.543 45.763l.568 2.05z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.114 372.33-.965.262-.764-2.818-.625-2.34C4.957 330.555.036 301.45 0 280.104l.004-1.358c.171-21.672 5.258-51.106 15.257-88.312l.763-2.819.965.262-.762 2.814-.623 2.335C5.83 229.83.964 258.859 1 280.103l.009 1.338c.238 21.571 5.35 50.93 15.34 88.063l.765 2.826z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.116 284.327-.964.267-.995-3.614-1.022-3.783c-5.423-20.28-8.134-34.007-8.134-41.219l.004-.539.015-.562c.274-8.135 3.462-23.273 9.563-45.455l.57-2.059.963.267-.78 2.83C10.111 213.17 7 228.358 7 235.979l.004.532.015.554c.273 8.026 3.45 23.109 9.528 45.21l.568 2.053z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    transform: "rotate(90 16.467 284)",
    cx: 16.467,
    cy: 284,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    transform: "rotate(90 16.467 372)",
    cx: 16.467,
    cy: 372,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    transform: "rotate(90 16.467 92)",
    cx: 16.467,
    cy: 92,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    transform: "rotate(90 16.467 188)",
    cx: 16.467,
    cy: 188,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    transform: "rotate(90 16.467 4)",
    cx: 16.467,
    cy: 4,
    r: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/connections.daf44e4e.svg";
export { ForwardRef as ReactComponent };